import React, { useState, useEffect } from "react";
import { API_BASE, authHeaders } from "./AgencyContext";

export default function AgencyReports() {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_BASE}/app/api/agency/clients`, { headers: authHeaders() })
      .then(r => r.ok ? r.json() : { clients: [] })
      .then(d => { setClients(d.clients || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const exportCsv = () => {
    const header = "Client,Email,Plan,Status,Onboarded\n";
    const rows = clients.map(c =>
      `"${c.client_name}","${c.client_email}","${c.plan}","${c.status}","${c.onboarded_at || ''}"`
    ).join("\n");
    const blob = new Blob([header + rows], { type: "text/csv" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `agency-report-${new Date().toISOString().slice(0,7)}.csv`;
    a.click();
  };

  const active = clients.filter(c => c.status === "active").length;

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <div style={{ fontSize: 22, fontWeight: 500 }}>Reports</div>
        <button onClick={exportCsv} style={{ background: "#0077B5", color: "#fff", border: "none", borderRadius: 6, padding: "8px 16px", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>Export CSV</button>
      </div>

      {loading ? (
        <div style={{ padding: 20, textAlign: "center", color: "#888" }}>Loading…</div>
      ) : (
        <>
          {/* Summary */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12, marginBottom: 20 }}>
            <div style={{ background: "#fff", border: "0.5px solid rgba(0,0,0,0.1)", borderRadius: 12, padding: 16, textAlign: "center" }}>
              <div style={{ fontSize: 12, color: "#888" }}>Total clients</div>
              <div style={{ fontSize: 24, fontWeight: 600 }}>{clients.length}</div>
            </div>
            <div style={{ background: "#fff", border: "0.5px solid rgba(0,0,0,0.1)", borderRadius: 12, padding: 16, textAlign: "center" }}>
              <div style={{ fontSize: 12, color: "#888" }}>Active</div>
              <div style={{ fontSize: 24, fontWeight: 600, color: "#1D9E75" }}>{active}</div>
            </div>
            <div style={{ background: "#fff", border: "0.5px solid rgba(0,0,0,0.1)", borderRadius: 12, padding: 16, textAlign: "center" }}>
              <div style={{ fontSize: 12, color: "#888" }}>Onboarding</div>
              <div style={{ fontSize: 24, fontWeight: 600, color: "#0C447C" }}>{clients.filter(c => c.status === "onboarding").length}</div>
            </div>
          </div>

          {/* Table */}
          <div style={{ background: "#fff", border: "0.5px solid rgba(0,0,0,0.1)", borderRadius: 12, overflow: "hidden" }}>
            <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr", padding: "10px 16px", background: "#f3f2ef", borderBottom: "0.5px solid rgba(0,0,0,0.1)" }}>
              {["CLIENT", "PLAN", "STATUS", "JOINED"].map(h => (
                <div key={h} style={{ fontSize: 10, fontWeight: 600, color: "#888", textTransform: "uppercase", letterSpacing: 0.5 }}>{h}</div>
              ))}
            </div>
            {clients.map((c, i) => (
              <div key={c.id} style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr", padding: "10px 16px", borderBottom: i < clients.length - 1 ? "0.5px solid rgba(0,0,0,0.05)" : "none", fontSize: 13 }}>
                <div style={{ fontWeight: 500 }}>{c.client_name}</div>
                <div>{c.plan}</div>
                <div>{c.status}</div>
                <div style={{ color: "#888" }}>{c.onboarded_at ? new Date(c.onboarded_at).toLocaleDateString() : "—"}</div>
              </div>
            ))}
            {/* Totals */}
            <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr", padding: "12px 16px", background: "#f3f2ef", fontWeight: 600, fontSize: 13 }}>
              <div>Total: {clients.length}</div>
              <div></div>
              <div>{active} active</div>
              <div></div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
